import {required, dropdownValidation} from '../../validations/Validatiors';
export const ValidationRules = [
    {
        field: 'message',
        method: required,
        message: 'Please enter message text.'
    },
    {
        field: 'message_category',
        method: required,
        message: 'Please select a category.'
    },
    {
        field: 'message_category',
        method: dropdownValidation,
        message: 'Please select a category.'
    }
];


// WEBPACK FOOTER //
// ./src/components/staffData/ValidationRules.js